<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        align-center
        mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3
        mx-5
      "
    >
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            Valida tu correo electrónico
          </h2>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p
            class="text-body-2 text-center grey--text text--darken-2 ma-0 mx-3"
          >
            Ingresa el código de verificación que hemos enviado a tu correo
            electrónico registrado.
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="11" xs="11" sm="8" md="8" lg="8" xl="8" class="ma-0 pa-0">
          <v-otp-input
            v-model="otp"
            class="seccion-otp"
            length="6"
            type="number"
            @keydown="verificarOTPEsNumerico"
            autocomplete="off"
          ></v-otp-input>
          <div class="d-flex flex-row justify-center align-center pa-0">
            <span class="text-body-2 grey--text text--darken-2">
              ¿No recibiste código?
            </span>
            <v-btn
              text
              color="primary"
              @click="reenviarOtp"
              :loading="cargandoReenvio"
              :disabled="cargandoReenvio || contador > 0"
              >{{ mensajeReenviar }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="11" xs="11" sm="9" md="9" lg="9" xl="12" class="ma-0 pa-0">
          <v-sheet class="pa-3 rounded-lg grey lighten-3">
            <div class="text-body-2 font-weight-bold mb-2">
              🔔 Recomendaciones:
            </div>
            <v-row dense>
              <v-col cols="12" class="d-flex align-center">
                <v-icon color="green" small>mdi-email</v-icon>
                <span class="text-caption ml-2"
                  >Revisa tu bandeja de entrada y también la carpeta de
                  SPAM.</span
                >
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-icon color="green" small>mdi-clock-outline</v-icon>
                <span class="text-caption ml-2"
                  >El código puede tardar hasta 1 minuto en llegar.</span
                >
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-icon color="green" small>mdi-refresh</v-icon>
                <span class="text-caption ml-2"
                  >No le des atrás, eso cambia el código.
                </span>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="12" class="ma-0 pa-0">
          <v-btn
            class="align-self-center"
            color="primary"
            elevation="3"
            :disabled="otp.length !== 6 || cargandoValidacion"
            :loading="cargandoValidacion"
            @click="submit"
            >Continuar<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Toolbar from '@/components/compartidos/Toolbar.vue'
import OtpService from '@/servicios/otp'
import Credito from '@/servicios/credito'
import { KEYS_VALIDAS_OTP, ALERTA_ERROR } from '@/utilidades/utilidades'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'ValidarCorreoOtp',
  components: {
    Toolbar,
  },
  mixins: [InsertaLogMixin],
  data: () => ({
    otp: '',
    cargandoReenvio: false,
    cargandoValidacion: false,
    contador: 60,
    interval: null,
  }),
  async created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.$store.commit('guia/establecerPasoActivo', { pasoActivo: 'correo' })
    this.iniciarContador()
    await this.resolverCorreoRegistrado()
    this.enviarOtpCorreo()
  },
  mounted() {
    this.InsertaLog()
  },
  computed: {
    mensajeReenviar() {
      return this.contador <= 0 ? 'Reenviar código' : 'Espere  ' + this.contador
    },
    siguienteRuta() {
      const bancaActiva = this.$store.getters['persona/obtenerEsBancaActiva']
      const tipoCredito =
        this.$store.getters['credito/obtenerCredito'].tipoCredito
      if (bancaActiva) {
        return tipoCredito == 245 || tipoCredito == 267
          ? 'referencia'
          : 'confirmacion'
      }
      return 'contrasena'
    },
  },
  methods: {
    async resolverCorreoRegistrado() {
      const correoActual =
        this.$store.getters['persona/obtenerCorreoRegistrado']
      if (correoActual) return

      const folio = this.$store.getters['credito/obtenerFolioDigital']
      if (!folio) return

      try {
        const result = await Credito.obtenerBanderasCorreo(folio)
        const modelo = result && result.data && result.data.Modelo
        if (!modelo) return

        const getField = (obj, name) => {
          if (!obj || typeof obj !== 'object') return undefined
          const key = Object.keys(obj).find(
            (k) => k.toLowerCase() === name.toLowerCase()
          )
          return key !== undefined ? obj[key] : undefined
        }

        const candidatos = [
          Array.isArray(modelo.Entidad) && Array.isArray(modelo.Entidad[0])
            ? modelo.Entidad[0][0]
            : null,
          modelo,
        ].filter(Boolean)

        let correo = ''
        for (const obj of candidatos) {
          correo =
            getField(obj, 'mail') ||
            getField(obj, 'correo') ||
            getField(obj, 'email') ||
            ''
          if (correo) break
        }

        console.log('[ValidarCorreoOtp] correo resuelto:', correo)
        if (correo) {
          this.$store.dispatch('persona/establecerCorreoRegistrado', correo)
        }
      } catch (e) {
        console.warn('[ValidarCorreoOtp] No se pudo resolver correo:', e)
      }
    },
    iniciarContador() {
      this.contador = 60
      this.interval = setInterval(() => {
        if (this.contador <= 0) clearInterval(this.interval)
        this.contador -= 1
      }, 1000)
    },
    verificarOTPEsNumerico(event) {
      if (!KEYS_VALIDAS_OTP.includes(event.key)) {
        event.preventDefault()
      }
    },
    async enviarOtpCorreo() {
      const request = this.$store.getters['persona/obtenerEnviarOtpV2Request']
      try {
        await OtpService.EnviarOtpV2(request)
      } catch {
        this.enviarAlertaError({
          mensaje: ALERTA_ERROR.mensaje,
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
      }
    },
    async reenviarOtp() {
      this.iniciarContador()
      this.otp = ''
      const request = {
        ...this.$store.getters['persona/obtenerEnviarOtpV2Request'],
        reenvio: true,
      }
      try {
        this.cargandoReenvio = true
        const result = await OtpService.EnviarOtpV2(request)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError({
            mensaje: result.data.Mensaje,
            tiempo: ALERTA_ERROR.tiempo,
            visibilidad: ALERTA_ERROR.visible,
          })
        }
        this.cargandoReenvio = false
      } catch {
        this.enviarAlertaError({
          mensaje: ALERTA_ERROR.mensaje,
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        this.cargandoReenvio = false
      }
    },
    async submit() {
      const esOtpCorrecto = await this.validarOtp()
      if (!esOtpCorrecto) return
      this.$store.dispatch('persona/establecerEmailValidado', true)
      this.$router.push(this.siguienteRuta)
    },
    async validarOtp() {
      const validaOtpRequest = {
        ...this.$store.getters['persona/obtenerValidaOtpCorreoRequest'],
        otp: this.otp,
      }
      let result
      try {
        this.cargandoValidacion = true
        result = await OtpService.ValidaOtp(validaOtpRequest)
        if (result.data.Codigo == 200 && result.data.Estado == true) {
          this.cargandoValidacion = false
          return true
        } else {
          this.enviarAlertaError({
            mensaje: result.data.Mensaje,
            tiempo: ALERTA_ERROR.tiempo,
            visibilidad: ALERTA_ERROR.visible,
          })
          this.cargandoValidacion = false
          return false
        }
      } catch {
        this.enviarAlertaError({
          mensaje: ALERTA_ERROR.mensaje,
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        this.cargandoValidacion = false
        return false
      }
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
}
</script>
